import LocomotiveScroll from 'locomotive-scroll';

export default (function () {
  'use strict';


  let lastScrollTop; // This Varibale will store the top position

  let navbars = document.querySelectorAll('.banner'); // Get The NavBar


  function showActive() {



    const scroll = new LocomotiveScroll({
      el: document.querySelector('body'),
      getDirection: true,
    });

    scroll.on('scroll', (instance) => {
        document.documentElement.setAttribute('data-direction', instance.direction)
    });

  }


  function init() {
    // approachAnimations()
    showActive()
    // approachAnims()
  }

  return {
    init: init
  };


  /* eslint-enable no-unused-vars */

})()
